import { Component, Input } from '@angular/core';
import IStatus from '../../../_interfaces/IStatus';
import { TagModule } from 'primeng/tag';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  standalone: true,
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  imports: [TagModule, TranslatePipe],
})
export class StatusComponent {
  @Input('status') status: IStatus;
}
